export default __webpack_public_path__ + "static/media/logo.e92df92a.png";